/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BondController,
  BondControllerInterface,
} from "../BondController";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "Mature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "Redeem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tranche",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RedeemMature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collateralToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_trancheFactory",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collateralToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "trancheRatios",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_maturityDate",
        type: "uint256",
      },
    ],
    name: "init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isMature",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maturityDate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tranche",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "redeemMature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "trancheCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "trancheTokenAddresses",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tranches",
    outputs: [
      {
        internalType: "contract ITranche",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "ratio",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type BondControllerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BondControllerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BondController__factory extends ContractFactory {
  constructor(...args: BondControllerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BondController> {
    return super.deploy(overrides || {}) as Promise<BondController>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BondController {
    return super.attach(address) as BondController;
  }
  connect(signer: Signer): BondController__factory {
    return super.connect(signer) as BondController__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BondControllerInterface {
    return new utils.Interface(_abi) as BondControllerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BondController {
    return new Contract(address, _abi, signerOrProvider) as BondController;
  }
}
